import { Component, OnInit, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { QuickQuoteService } from '../../services/quickquote-service.service';
import { PershingTranslationService } from '@pershing/pershing-core';

@Component({
  selector: 'market-alerts-agreement',
  templateUrl: './market-alerts-agreement.component.html',
})
export class MarketAlertsAgreementComponent implements OnInit {
  isMarketAlertsResp: any = false;
  isAgreeDisabled: any = false;
  marketAlertsData: any;
  marketAlertsStatus: any;
  accountNumber: any;
  constructor(
    private dialog: MatDialog,
    public QuickQuoteService: QuickQuoteService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MarketAlertsAgreementComponent>,
    private translationService: PershingTranslationService
  ) {
    this.translationService.addTranslationFolder(
      '@pershing/nxi-ng-mod',
      'node_modules/@pershing/nxi-ng-mod/lib'
    );
  }

  ngOnInit() {
    if (this.data.isAdvisor) {
      this.isAgreeDisabled = true;
    }
  }

  onMarketAlertsAgree() {
    this.marketAlertsData = this.data;
    this.QuickQuoteService.setMarketAlertsAggrement().subscribe({
      next: (response: any) => {
        if (response && response.errors && response.errors.errorCode == 0) {
          this.isMarketAlertsResp = true;
          document.cookie =
            'AlertsSigned=' + escape(this.isMarketAlertsResp) + '; path=/';
          this.accountNumber = this.data.data;
          if (this.data.status === 'yes') {
            this.closeMarketAlertsAgreeDialog();
          }
        } else {
          this.onClose();
        }
      },
      error: (error: any) => {
        this.dialogRef.close({ isErrorOccured: true });
        console.log('Error in Market Alerts Agreements' + error);
      },
    });
  }

  closeMarketAlertsAgreeDialog() {
    this.dialogRef.close({ isErrorOccured: false });
  }

  onClose() {
    this.dialogRef.close({ isErrorOccured: false });
    document.dispatchEvent(
      new CustomEvent('portal.gotoview', {
        detail: {
          domain: 'account',
          value: '',
          gotoPage: '/nxi/research/investtools',
        },
      })
    );
  }
}
